import { useEffect, useRef, useState } from 'react';
import config from '../../../../../config';
import { useTranslation } from 'react-i18next';
import Idiom from '../../../../organisms/Navbar/components/Idiom';
import { isBaNorte } from 'utils/contants';
import { apiCall } from 'crud/api.crud';
import { Link } from 'react-router-dom';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import useStore from '../../../../../store/zustand/store';

const entity_id = Number(process.env.REACT_APP_ID_ENTITY);

const BaNorte = () => {
  const [step, setStep] = useState(0);
  const [employee, setEmployee] = useState('');
  const [userType, setUserType] = useState('employee');

  const stepComponent = [
    <StepOne key={`stepOne-${step}`} next={setStep} employee={employee} setEmployee={setEmployee} userType={userType} setUserType={setUserType} />,
    userType === 'family' 
      ? <StepTwoFamily key={`stepTwoFamily-${step}`} previous={setStep} employee={employee} />
      : <StepTwoEmployee key={`stepTwoEmployee-${step}`} previous={setStep} employee={employee} />,
  ];

  return stepComponent[step];
};

export default BaNorte;

const StepOne = ({employee, next, setEmployee, userType, setUserType })=>{
  const { t } = useTranslation();
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);

  const inputRef = useRef();

  useEffect(() => {
    inputRef.current.focus();
  },[] );

  const onSubmit = async () => {
    if (!userType) {
      setError(true);
      return;
    }

    setLoading(true);
    setError(false);

    try {
      const { data } = await apiCall(`entity/${entity_id}/employee-numbers/validate`, { employee }, 'POST');
      if (data) {
        next(1);
      } else {
        setError(true);
      }
    } catch (err) {
      console.error('Error al verificar empleado:', err);
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <h6 style={{ fontWeight: '700', color: 'grey' }}>{config.login_message ?? ''}</h6>
      <h5 className="mb-4">{isBaNorte ? t('home.public_msg9') : t('home.public_msg3')}</h5>
      <div className="w-100">
        <div className="vm-100 mb-3 col-12 p-0">
          <input
            type="text"
            className={`input-text ${error && 'input-text--danger'}`}
            placeholder="123-345656"
            onChange={(e) => setEmployee(e.target.value)}
            value={employee}
            name="employee"
            ref={inputRef}
          />
        </div>

        <div className="mb-4">
          <div className="d-flex justify-content-around">
            <button 
              className={`button ${userType === 'employee' ? '' : 'button--white'} mb-2`}
              onClick={() => setUserType('employee')}
              type="button"
            >
              Soy coloborador
            </button>
            <button 
              className={`button ${userType === 'family' ? '' : 'button--white'} mb-2`}
              onClick={() => setUserType('family')}
              type="button"
            >
              Soy familiar
            </button>
          </div>
        </div>

        {error && <span className="span span--error">
          {!userType ? 'Selecciona si eres empleado o familiar' : t('auth.msg_error2')}
        </span>}

        <button className="button mt-3 mb-5 w-100" onClick={onSubmit}>
          {loading ? t('button.button_msg10') : t('button.button_msg2')}
        </button>
      </div>
      <Idiom />
    </>
  );
}

const StepTwoEmployee = ({ previous, employee }) => {
  const { t } = useTranslation();

  const [showPass, setShowPass] = useState(false);
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const handleNumber = useStore((state) => state.handleNumber);

  const loginApi = useStore((state) => state.login);
  const inputRef = useRef();

  useEffect(() => {
    setError(false);
  }, []);

  useEffect(() => {
    inputRef.current.focus();
  });

  const handleOnKeyDown = (e) => {
    if (e.keyCode === 13) {
      login();
    }
  };

  const login = async () => {
    if (!password) {
      setError(true);
      return;
    }

    setLoading(true);
    setError(false);

    const payload = {
      employee_number: employee,
      password,
    };

    try {
      const response = await apiCall('loginEmployee', payload, 'POST');
      const data = response.data.data[0];
      handleNumber(employee);
      loginApi(data);
    } catch (error) {
      console.error('Error en login empleado:', error);
      setLoading(false);
      setError(true);
    }
  };

  const setPreviousStep = () => {
    previous(0);
  };

  const changeShowPass = () => {
    setShowPass(!showPass);
  };

  return (
    <>
      <h5>{t('home.public_msg4')}</h5>
      <div className="w-100 mt-4">
        <fieldset disabled>
          <input type="text" id="disabledTextInput" className="input-text" placeholder={employee} />
        </fieldset>
      </div>
      <div className="password-wrapper mt-4">
        <input
          type={showPass ? 'text' : 'password'}
          className={`input-text ${error && 'input-text--danger'}`}
          placeholder="&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;"
          onChange={(e) => setPassword(e.target.value)}
          onKeyDown={handleOnKeyDown}
          value={password}
          name="password"
          ref={inputRef}
        />
        {showPass ? (
          <FaEyeSlash className="password-eye" onClick={changeShowPass}></FaEyeSlash>
        ) : (
          <FaEye className="password-eye" onClick={changeShowPass}></FaEye>
        )}
      </div>
      {error && <span className="span span--error pt-1">{t('home.public_msg5')}</span>}
      <Link to={{ pathname: '/reset', employeeProp: { employee } }} className="link mt-2">
        {t('home.public_msg6')}
      </Link>
      <div className="d-flex justify-content-around w-100">
        <button className="button button--white mt-3 mb-5" onClick={setPreviousStep}>
          {t('button.button_msg16')}
        </button>
        <button className="button mt-3 mb-5" onClick={login}>
          {loading ? t('button.button_msg10') : t('button.button_msg17')}
        </button>
      </div>

      <div className="d-flex justify-content-between w-100 align-items-center">
        <Idiom />
        <Link to={{ pathname: '/register', employeeProp: { employee }, isFamilyProp: { isFamilyProp:false } }}>{t('home.public_msg1')}</Link>
      </div>
    </>
  );
};

const StepTwoFamily = ({ previous, employee }) => {
  const { t } = useTranslation();

  const [showPass, setShowPass] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const handleNumber = useStore((state) => state.handleNumber);

  const loginApi = useStore((state) => state.login);
  const emailRef = useRef();

  useEffect(() => {
    setError(false);
  }, []);

  useEffect(() => {
    emailRef.current.focus();
  },[]);

  const handleOnKeyDown = (e) => {
    if (e.keyCode === 13) {
      login();
    }
  };

  const login = async () => {
    if (!email || !password) {
      setError(true);
      return;
    }

    setLoading(true);
    setError(false);

    const payload = {
      employee_number: employee,
      email,
      password,
    };

    try {
      const response = await apiCall('loginFamilyMember', payload, 'POST');
      const data = response.data.data[0];
      handleNumber(employee);
      loginApi(data);
    } catch (error) {
      console.error('Error en login familiar:', error);
      setLoading(false);
      setError(true);
    }
  };

  const setPreviousStep = () => {
    previous(0);
  };

  const changeShowPass = () => {
    setShowPass(!showPass);
  };

  return (
    <>
      <h5>Iniciar sesión como familiar</h5>
      <div className="w-100 mt-4">
        <fieldset disabled>
          <input type="text" id="disabledTextInput" className="input-text" placeholder={employee} />
        </fieldset>
      </div>
      <div className="w-100 mt-4">
        <input
          type="email"
          className={`input-text ${error && 'input-text--danger'}`}
          placeholder="usuario@email.com"
          onChange={(e) => setEmail(e.target.value)}
          onKeyDown={handleOnKeyDown}
          value={email}
          name="email"
          ref={emailRef}
        />
      </div>
      <div className="password-wrapper mt-4">
        <input
          type={showPass ? 'text' : 'password'}
          className={`input-text ${error && 'input-text--danger'}`}
          placeholder="&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;"
          onChange={(e) => setPassword(e.target.value)}
          onKeyDown={handleOnKeyDown}
          value={password}
          name="password"
        />
        {showPass ? (
          <FaEyeSlash className="password-eye" onClick={changeShowPass}></FaEyeSlash>
        ) : (
          <FaEye className="password-eye" onClick={changeShowPass}></FaEye>
        )}
      </div>
      {error && <span className="span span--error pt-1">Verifica tu número de empleado, email y contraseña</span>}
      <Link to={{ pathname: '/reset', employeeProp: { employee } }} className="link mt-2">
        {t('home.public_msg6')}
      </Link>
      <div className="d-flex justify-content-around w-100">
        <button className="button button--white mt-3 mb-5" onClick={setPreviousStep}>
          {t('button.button_msg16')}
        </button>
        <button className="button mt-3 mb-5" onClick={login}>
          {loading ? t('button.button_msg10') : t('button.button_msg17')}
        </button>
      </div>

      <div className="d-flex justify-content-between w-100 align-items-center">
        <Idiom />
        <Link to={{ pathname: '/register', employeeProp: { employee },isFamilyProp: { isFamilyProp:true } }} >{t('home.public_msg1')}</Link>
      </div>
    </>
  );
};